import { handleActions } from "redux-actions";
import { fromJS } from "immutable";
import types from "../types";

const INITIAL_STATE = fromJS({
  isLoading: false,
  isLoadingRegister: false,
  token: "",
  message: "",
});

const reducer = handleActions(
  {
    [types.GET_ACCESS_TOKEN]: (state, { payload }) =>
      state.set("isLoading", true),
    [types.GET_ACCESS_TOKEN_FAIL]: (state, { payload }) =>
      state.set("isLoading", false),
    [types.GET_ACCESS_TOKEN_SUCCESS]: (state, { payload: response }) =>
      state.set("isLoading", false).set("token", response.data.token),
    [types.REGISTER]: (state, { payload }) =>
      state.set("isLoadingRegister", true),
    [types.REGISTER_FAIL]: (state, { payload }) =>
      state.set("isLoadingRegister", false),
    [types.REGISTER_SUCCESS]: (state, { payload: response }) =>
      state
        .set("isLoadingRegister", false)
        .set("message", response.data.message),
  },
  INITIAL_STATE
);

export default reducer;
